module.exports = __webpack_public_path__ + "static/media/phone-applicant.e1196798.png";